export default __webpack_public_path__ + "static/media/include_14_male@2x.0932a9de.jpg";